/**
 * The palettes the rail can wear.
 *
 * Named rather than free-form colour: a colour picker on a navigation bar produces unreadable
 * combinations within about a minute, and contrast against white text is not something to leave to
 * chance. Each palette here is a pair of backgrounds and an accent that has been checked against the
 * text it carries.
 *
 * The choice is a user preference, not a tenant one — it is about the person's eyes, not the brand.
 */

export interface RailTheme {
  key: string;
  labelKey: string;
  /** What the swatch shows: the gradient the rail actually uses. */
  from: string;
  to: string;
  accent: string;
}

export const RAIL_THEMES: RailTheme[] = [
  {
    key: 'midnight',
    labelKey: 'theme.midnight',
    from: '#101828',
    to: '#0b1220',
    accent: '#2d5bff',
  },
  {
    key: 'graphite',
    labelKey: 'theme.graphite',
    from: '#1f2227',
    to: '#141619',
    accent: '#6d43e8',
  },
  { key: 'indigo', labelKey: 'theme.indigo', from: '#2a2159', to: '#171034', accent: '#8b5cf6' },
  { key: 'forest', labelKey: 'theme.forest', from: '#10291f', to: '#0a1a13', accent: '#34d399' },
  { key: 'plum', labelKey: 'theme.plum', from: '#31152b', to: '#1d0c19', accent: '#f472b6' },
  { key: 'ocean', labelKey: 'theme.ocean', from: '#0c2a3a', to: '#071a25', accent: '#38bdf8' },
  { key: 'light', labelKey: 'theme.light', from: '#f4f5f7', to: '#e9ebef', accent: '#2d5bff' },
];

export const DEFAULT_RAIL_THEME = 'midnight';

export function isRailTheme(value: unknown): value is string {
  return typeof value === 'string' && RAIL_THEMES.some((theme) => theme.key === value);
}
